import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateActivityItemMutation as UpdateActivityItemMutationType,
  UpdateActivityItemMutationVariables,
} from "./__generated__/UpdateActivityItemMutation";

const UpdateActivityItemMutation = loader("./UpdateActivityItemMutation.gql");

type UpdateActivityItemMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateActivityItemMutationType) => void;
}) => ReactElement;

export const UpdateActivityItemMutationProvider: UpdateActivityItemMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateActivityItemMutationType, UpdateActivityItemMutationVariables>(
    UpdateActivityItemMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
